import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { CaptchaWidgetProps } from './CaptchaWidget';
import { CONFIG } from '~/config';

const GoogleRecaptchaWidget: React.FC<CaptchaWidgetProps> = ({ onVerify }) => {
  return (
    <ReCAPTCHA
      sitekey={CONFIG.env.recaptchaSiteKey || ''}
      onChange={onVerify}
    />
  );
};

export default GoogleRecaptchaWidget;
